import { render, staticRenderFns } from "./Loanindex.vue?vue&type=template&id=a84d4d76&"
import script from "./Loanindex.vue?vue&type=script&lang=js&"
export * from "./Loanindex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports